import { FC, useState } from 'react';
import { Col, Modal, Row } from 'antd';

import { useAntDesignTheme } from '@/hooks/useAntDesignTheme';
import { SetStateMethod } from '@/types';

import Sider from './layout/01-Sider';
import Content from './layout/02-Content';
import { OAuthApplication, OAuthApplicationModalView } from './types';

interface CreateOAuthApplicationModalProps {
    open: boolean;
    setOpen: SetStateMethod<boolean>;
    activeView?: OAuthApplicationModalView;
    onCreated?: (oauthApplication: OAuthApplication) => void;
}

const CreateOAuthApplicationModal: FC<CreateOAuthApplicationModalProps> = ({
    open,
    setOpen,
    activeView,
    onCreated,
}) => {
    const [view, setView] = useState<OAuthApplicationModalView>(activeView ?? 'add');
    const { token } = useAntDesignTheme();

    return (
        <Modal
            destroyOnHidden
            mask={false}
            open={open}
            width='min(88rem, calc(100vw - 4rem))'
            closable={false}
            closeIcon={null}
            styles={{
                body: { height: '54rem', maxHeight: 'calc(100vh - 6rem)', overflow: 'hidden' },
                content: { padding: 0, margin: 0, border: `1px solid ${token.colorBorder}` },
            }}
            footer={null}
            onCancel={() => setOpen(false)}
            afterOpenChange={(isOpen) => {
                if (isOpen) {
                    setView(activeView ?? 'add');
                }
            }}
        >
            <Row wrap={false} style={{ height: '100%' }}>
                <Col span={7} style={{ height: '100%' }}>
                    <Sider view={view} setView={setView} />
                </Col>
                <Col flex='auto' style={{ minWidth: 0, height: '100%', borderLeft: `1px solid ${token.colorBorder}` }}>
                    <Content view={view} setOpen={setOpen} onCreated={onCreated} />
                </Col>
            </Row>
        </Modal>
    );
};

export default CreateOAuthApplicationModal;
